"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.assign.js");

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _RaisedButton = _interopRequireDefault(require("material-ui/RaisedButton"));

var _Card = require("material-ui/Card");

var _utils = require("../../../lib/utils");

var _downChevron2x = _interopRequireDefault(require("../../../images/dash/down-chevron@2x.png"));

require("../../../sass/components/shared/elements/ExpanderAnnouncementReview.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var wrapSvgIcon = function wrapSvgIcon(icon) {
  if (!icon) return;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "svg-icon-bg"
  }, icon);
};

var makeCornerImage = function makeCornerImage(urlKey, row) {
  return urlKey && row[urlKey] && /*#__PURE__*/_react.default.createElement("div", {
    className: "corner-image",
    style: {
      backgroundImage: "url(".concat(row[urlKey], ")")
    }
  });
};

var getBodyClass = function getBodyClass(valid) {
  return (0, _classnames.default)({
    valid: valid,
    'expander-review-body': true
  });
};

var defaultGroupClass = {
  'standard-dash-form repeater-form': true
};

var RepeaterGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(RepeaterGroup, _React$Component);

  var _super = _createSuper(RepeaterGroup);

  function RepeaterGroup(props) {
    var _this;

    _classCallCheck(this, RepeaterGroup);

    _this = _super.call(this, props);
    _this.onExpandChange = _this.onExpandChange.bind(_assertThisInitialized(_this));
    _this.handleAnalytics = _this.handleAnalytics.bind(_assertThisInitialized(_this));
    _this.handleSave = _this.handleSave.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(RepeaterGroup, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        idx: this.props.idx
      };
    }
  }, {
    key: "onExpandChange",
    value: function onExpandChange(expanded) {
      var _this$props = this.props,
          idx = _this$props.idx,
          validatePage = _this$props.validatePage,
          isActive = _this$props.isActive,
          setActiveIdx = _this$props.setActiveIdx,
          setAllShut = _this$props.setAllShut;

      if (!expanded && isActive) {
        if (validatePage(idx)) {
          return setAllShut();
        }
      } else if (expanded) {
        return setActiveIdx(idx);
      }
    }
  }, {
    key: "handleAnalytics",
    value: function handleAnalytics(type) {
      var analyticsObject = this.props.analyticsObject;
      analyticsObject && analyticsObject[type] && (0, _utils.googleAnalytics)(analyticsObject[type])();
    }
  }, {
    key: "handleSave",
    value: function handleSave(saveFn) {
      if (saveFn) {
        saveFn();
      } else {
        this.onExpandChange(false);
      }

      this.handleAnalytics('save');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props,
          onExpandChange = this.onExpandChange;
      var children = props.children,
          idx = props.idx,
          row = props.row,
          rowsLen = props.rowsLen,
          isActive = props.isActive,
          svgIcon = props.svgIcon,
          _props$svgIconFn = props.svgIconFn,
          svgIconFn = _props$svgIconFn === void 0 ? function () {} : _props$svgIconFn,
          title = props.title,
          subTitle = props.subTitle,
          subTitleFn = props.subTitleFn,
          titleFn = props.titleFn,
          groupClass = props.groupClass,
          saveFn = props.saveFn,
          isPageValid = props.isPageValid,
          cornerImageKey = props.cornerImageKey,
          deleteRowAndDecrement = props.deleteRowAndDecrement,
          modifiedArray = props.modifiedArray;
      var formClass = (0, _classnames.default)(Object.assign(_defineProperty({}, groupClass, true), defaultGroupClass));

      var viewIcon = /*#__PURE__*/_react.default.createElement("div", {
        className: "view-icon",
        onClick: function onClick(e) {
          return _this2.handleAnalytics('close');
        }
      }, /*#__PURE__*/_react.default.createElement("p", null, "View"), /*#__PURE__*/_react.default.createElement("img", {
        src: _downChevron2x.default
      }));

      var closeIcon = /*#__PURE__*/_react.default.createElement("div", {
        className: "close-icon",
        onClick: function onClick(e) {
          return _this2.handleAnalytics('view');
        }
      }, /*#__PURE__*/_react.default.createElement("p", null, "Close"), /*#__PURE__*/_react.default.createElement("img", {
        src: _downChevron2x.default
      }));

      return /*#__PURE__*/_react.default.createElement("div", {
        className: getBodyClass(isPageValid(idx))
      }, /*#__PURE__*/_react.default.createElement(_Card.Card, {
        className: "expander-review-card",
        expanded: isActive,
        onExpandChange: onExpandChange
      }, /*#__PURE__*/_react.default.createElement(_Card.CardHeader, {
        className: "expander-card-header",
        style: {
          display: 'flex'
        },
        title: titleFn(row, idx),
        subtitle: subTitleFn && subTitleFn(row) || subTitle,
        subtitleStyle: {
          fontSize: '1.6rem'
        },
        avatar: wrapSvgIcon(svgIconFn(idx)) || makeCornerImage(cornerImageKey, row) || wrapSvgIcon(svgIcon),
        actAsExpander: true,
        showExpandableButton: true,
        closeIcon: viewIcon,
        openIcon: closeIcon
      }), /*#__PURE__*/_react.default.createElement(_Card.CardText, {
        expandable: true,
        className: "repeater-body"
      }, /*#__PURE__*/_react.default.createElement("form", {
        className: formClass
      }, children), /*#__PURE__*/_react.default.createElement(_Card.CardActions, {
        className: "expander-review-edit"
      }, /*#__PURE__*/_react.default.createElement(_RaisedButton.default, {
        label: /*#__PURE__*/_react.default.createElement("span", null, "Delete", /*#__PURE__*/_react.default.createElement("span", {
          className: "optional-title"
        }, "\xA0", title)),
        labelStyle: {
          textTransform: 'none'
        },
        disabled: rowsLen < 2,
        className: "expander-review-button",
        onClick: function onClick() {
          deleteRowAndDecrement(null, idx);

          _this2.handleAnalytics('delete');
        },
        style: {
          marginLeft: 'auto',
          marginTop: '6.7rem'
        }
      }), /*#__PURE__*/_react.default.createElement(_RaisedButton.default, {
        disabled: modifiedArray && !modifiedArray[idx],
        primary: true,
        label: /*#__PURE__*/_react.default.createElement("span", null, "Save", /*#__PURE__*/_react.default.createElement("span", {
          className: "optional-title"
        }, "\xA0", title)),
        className: "expander-review-button",
        labelStyle: {
          textTransform: 'none'
        },
        onClick: function onClick() {
          _this2.handleSave(saveFn);
        },
        style: {
          marginLeft: 'auto',
          marginTop: '6.7rem'
        }
      })))));
    }
  }]);

  return RepeaterGroup;
}(_react.default.Component);

exports.default = RepeaterGroup;
RepeaterGroup.childContextTypes = {
  idx: _propTypes.default.number
};
RepeaterGroup.propTypes = {
  row: _propTypes.default.object,
  rowsLen: _propTypes.default.number,
  isActive: _propTypes.default.bool,
  title: _propTypes.default.string,
  svgIcon: _propTypes.default.element,
  svgIconFn: _propTypes.default.func,
  subTitle: _propTypes.default.string,
  subTitleFn: _propTypes.default.func,
  groupClass: _propTypes.default.string,
  cornerImageKey: _propTypes.default.string,
  saveFn: _propTypes.default.func,
  setAllShut: _propTypes.default.func.isRequired,
  isPageValid: _propTypes.default.func.isRequired,
  validatePage: _propTypes.default.func.isRequired,
  setActiveIdx: _propTypes.default.func.isRequired,
  deleteRowAndDecrement: _propTypes.default.func.isRequired
};